module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS"), _c('br'), _vm._v("New York and London")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 1994 by New York University"), _c('br'), _vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Feminist nightmares : women at odds : feminism and the problem of"), _c('br'), _vm._v("sisterhood / edited by Susan Ostrov Weisser and Jennifer Fleischner."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("Includes bibliographical references and index."), _c('br'), _vm._v("ISBN 0-8147-2619-4.—ISBN 0-8147-2620-8 (pbk.)"), _c('br'), _vm._v("I. Feminism. 2. Feminism—Moral and ethical aspects."), _c('br'), _vm._v("3. Feminism—United States. I. Weisser, Susan Ostrov."), _c('br'), _vm._v("II. Fleischner, Jennifer."), _c('br'), _vm._v("HQ1190.F4616   1994"), _c('br'), _vm._v("305.42—dc2o              94-26606")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v(" CIP")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("New York University Press books are printed on acid-free paper,"), _c('br'), _vm._v("and their binding materials are chosen for strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662c7b76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0